export default {
    route: {
        hidden: true,
        meta: {
            title: '产品详情'
        }
    }
}
